import type { SavedSearchFrequency } from '@/src/lib/savedSearches';

export const SAVED_SEARCH_EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const SAVED_SEARCH_FREQUENCY_OPTIONS: Array<SavedSearchFrequency> = ['instant', 'daily', 'weekly', 'never'];

export const SAVED_SEARCH_FREQUENCY_LABEL_KEYS: Record<
  SavedSearchFrequency,
  'frequencyInstant' | 'frequencyDaily' | 'frequencyWeekly' | 'frequencyNever'
> = {
  instant: 'frequencyInstant',
  daily: 'frequencyDaily',
  weekly: 'frequencyWeekly',
  never: 'frequencyNever',
};

type SaveSearchErrorKey = 'errorName' | 'errorEmailRequired' | 'errorEmailInvalid';
type SaveSearchErrorTranslator = (key: SaveSearchErrorKey) => string;

export function getSavedSearchNameError(name: string, t: SaveSearchErrorTranslator): string | undefined {
  return name.trim() ? undefined : t('errorName');
}

export function getSavedSearchEmailError(email: string, t: SaveSearchErrorTranslator): string | undefined {
  const trimmedEmail = email.trim();

  if (!trimmedEmail) {
    return t('errorEmailRequired');
  }

  if (!SAVED_SEARCH_EMAIL_PATTERN.test(trimmedEmail)) {
    return t('errorEmailInvalid');
  }

  return undefined;
}
